import { render, staticRenderFns } from "./LoaderBlock.vue?vue&type=template&id=79fcae3b&"
import script from "./LoaderBlock.vue?vue&type=script&lang=js&"
export * from "./LoaderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports